<script setup>
defineProps({
  header: {
    type: String
  },
  headerTag: {
    type: String,
    default: 'header'
  },
  headerClasses: {
    type: [Array, Object, String]
  },
  id: {
    type: String
  },
  headerAttrs: {
    type: Object,
    default: () => ({})
  },
  menuClasses: {
    type: [Array, Object, String]
  }
})
defineOptions({
  inheritAttrs: false
})
</script>

<template>
  <t-dropdown-header
    v-bind="headerAttrs"
    :id="id ? `tasty_${id}_dd_group_header` : null"
    :header-tag="headerTag"
    :class="[headerClasses]"
  >
    <slot name="header">{{ header }}</slot>
  </t-dropdown-header>
  <ul
    :id="id"
    class="t-dropdown-group list-unstyled"
    :class="menuClasses"
    role="group"
  >
    <slot></slot>
  </ul>
</template>

<style scoped lang="scss"></style>
